<template>
  <div class="container-fluid app app--red app--dobrodelen">
    <div class="app__width-container">
      <header class="app__title">
        <h1><span>1 %</span> dohodnine</h1>
      </header>
      <div class="row">
        <div class="col-lg-offset-1 col-lg-10">
          <div class="jumbotron">
            <p>Vsak, ki v Sloveniji plačuje dohodnino, lahko do 1 % svoje dohodnine nameni nevladnim organizacijam. Vsak davčni zavezanec lahko izbere največ deset organizacij in s tem odstotek svoje dohodnine nameni za njihovo delovanje. Takšna donacija ga nič ne stane, saj gre ta odstotek sicer v proračun.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-offset-1 col-lg-7 questions">
        <!-- QUESTION 1 -->
        <div v-if="!actualAnswer1" id="question-1" class="question clearfix">
          <div class="question__number">1</div>
          <div class="question__content">
            <div class="question__label">
              Kdo ste?
            </div>
            <div class="question__answers">
              <form>
                <div class="radio">
                  <input type="radio" id="question-1-1" value="person" v-model="answer1">
                  <label for="question-1-1">Posameznik/-ca, ki želi darovati del dohodnine</label>
                </div>
                <div class="radio">
                  <input type="radio" id="question-1-2" value="org" v-model="answer1">
                  <label for="question-1-2">Organizacija, ki želi prejemati donacijo</label>
                </div>
              </form>
            </div>
            <div class="question__button">
              <button type="button" class="btn btn-primary btn-external" :disabled="!answer1" @click="onNextAnswer1">Naprej</button>
            </div>
          </div>
        </div>
        <!-- QUESTION 2 -->
        <template v-if="actualAnswer1 === 'person'">
          <div v-if="!actualAnswer2" id="question-2" class="question clearfix">
            <div class="question__number">2</div>
            <div class="question__content">
              <div class="question__answers">
                <form>
                  <div class="radio">
                    <input type="radio" id="question-2-1" value="edavki" v-model="answer2">
                    <label for="question-2-1">Že imam izbrano organizacijo, daroval bom prek sistema eDavki.</label>
                  </div>
                  <div class="radio">
                    <input type="radio" id="question-2-2" value="find_org" v-model="answer2">
                    <label for="question-2-2">Želim poiskati organizacijo oziroma izpolniti obrazec.</label>
                  </div>
                </form>
              </div>
              <div class="question__button">
                <button type="button" class="btn btn-primary btn-external" :disabled="!answer2" @click="onNextAnswer2">Naprej</button>
              </div>
            </div>
          </div>
          <!-- QUESTION 3 -->
          <div id="question-3" class="question clearfix" v-if="actualAnswer2 == 'edavki'">
            <div class="question__number">3</div>
            <div class="question__content">
              <div>
                <p>Zahtevo za namenitev dela dohodnine za donacije je možno oddati kadarkoli prek sistema eDavki z digitalnim potrdilom ali brez. Če želite v eDavke vstopiti brez digitalnega potrdila, boste potrebovali svojo <strong>davčno številko</strong> in <strong>številko zadnjega informativnega izračuna dohodnine</strong>. Za namenitev dela dohodnine pa boste potrebovali še <strong>davčno številko izbrane organizacije</strong>.</p>
                <p>Davčni organ upošteva veljavne zahteve, s katerimi razpolaga na dan 31. decembra tistega leta, za katero se dohodnina odmerja. Za leto 2024 tako velja, da bo davčni organ upošteval veljavne zahtevke, s katerimi bo razpolagal do 31. decembra 2024. Zahteva velja do trenutka, ko davčni organ prejme novo zahtevo ali preklic zahteve.</p>
              </div>
              <div class="question__button">
                <a href="https://edavki.durs.si/EdavkiPortal/OpenPortal/CommonPages/Opdynp/PageD.aspx?category=namenitev_dela_dohodnine_fo" target="_blank" class="btn btn-primary btn-external">pojdi na eDavke</a>
              </div>
            </div>
          </div>
          <div id="question-3" class="question clearfix" v-if="actualAnswer2 == 'find_org'">
            <div class="question__number">3</div>
            <div class="question__content">
              <div class="question__label">
                <p><strong>Izberete lahko od 1 do 10 organizacij, med katerimi lahko porazdelite do 1 % svoje dohodnine. Če še niste povsem odločeni, jih dodajte s klikom na zvezdico. Izbor boste lahko pred izpolnitvijo obrazca še enkrat uredili.</strong></p>
                <p id="find-org-radios">IŠČI PO:</p>
              </div>
              <div class="question__answers">
                <form>
                  <div class="radio">
                    <input type="radio" id="question-3-1" value="1" v-model="answer3">
                    <label for="question-3-1">nazivu</label>
                  </div>
                  <div class="radio">
                    <input type="radio" id="question-3-2" value="2" v-model="answer3">
                    <label for="question-3-2">davčni številki</label>
                  </div>
                  <div class="radio">
                    <input type="radio" id="question-3-3" value="3" v-model="answer3">
                    <label for="question-3-3">poštni številki</label>
                  </div>
                  <div class="radio">
                    <input type="radio" id="question-3-4" value="4" v-model="answer3">
                    <label for="question-3-4">področju</label>
                  </div>
                </form>
              </div>
              <div class="question__label">
                <input class="form-control" placeholder="Vpišite ključno besedo" v-model="findOrgKeyword" v-if="answer3 === '1'">
                <input class="form-control" placeholder="Vpišite davčno številko" v-model="findOrgTaxNumber" v-if="answer3 === '2'">
                <input class="form-control" placeholder="Vpišite poštno številko" v-model="findOrgPostal" v-if="answer3 === '3'">
                <search-dropdown single :placeholder="areasPlaceholder" :items="areas" @change="(v) => findOrgArea = v.value" v-if="answer3 === '4'"></search-dropdown>
              </div>
              <div class="question__label" v-if="findOrgLoading">
                <div class="loader"></div>
              </div>
              <div class="question__label" v-if="findOrgResults">
                <p>Rezultati ({{findOrgResults.length}}):</p>
                <div class="star-list">
                  <div :class="['star-list__entry', { 'star-list__entry--selected': isSelectedOrg(org) }]" v-for="org in findOrgResults" @click="selectOrg(org)">
                    {{org.name}}
                  </div>
                </div>
              </div>
              <div class="question__label" v-if="selectedTooMany">
                <p><strong class="text-danger">Izberete lahko največ 10 orgranizacij!</strong></p>
              </div>
              <div class="question__label" v-if="selected_orgs.length">
                <p>Izbrane organizacije:</p>
                <ul class="question__selected-list">
                  <li v-for="org in selected_orgs" :key="org.tax_number">
                    <small><strong>{{org.name}}</strong> (DŠ: {{org.tax_number}})</small>
                    <button type="button" class="close" @click.prevent="selectOrg(org)" aria-label="Remove" title="Odstrani">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </li>
                </ul>
                <p class="text-center question__button">
                  <button class="btn btn-primary" @click.prevent="selectRatios">Nadaljuj z odmero dela dohodnine</button>
                  <button class="btn btn-primary" @click.prevent="continueToEdavki">Daruj preko sistema eDavki</button>
                </p>
              </div>
            </div>
          </div>
          <div id="question-4" class="question clearfix" v-if="!showSelectRatios && answer4 == 'edavki'">
            <div class="question__number">4</div>
            <div class="question__content">
              <div class="question__label">
                <p>Zahtevo za namenitev dela dohodnine za donacije je možno oddati kadarkoli prek sistema eDavki z digitalnim potrdilom ali brez. Če želite v eDavke vstopiti brez digitalnega potrdila, boste potrebovali svojo <strong>davčno številko</strong> in <strong>številko zadnjega informativnega izračuna dohodnine</strong>. Za namenitev dela dohodnine pa boste potrebovali še <strong>davčno številko izbrane organizacije</strong>.</p>
                <p>Davčni organ upošteva veljavne zahteve, s katerimi razpolaga na dan 31. decembra tistega leta, za katero se dohodnina odmerja. Za leto 2024 tako velja, da bo davčni organ upošteval veljavne zahtevke, s katerimi bo razpolagal do 31. decembra 2024. Zahteva velja do trenutka, ko davčni organ prejme novo zahtevo ali preklic zahteve.</p>
                <p class="question__button">
                  <a href="https://edavki.durs.si/EdavkiPortal/OpenPortal/CommonPages/Opdynp/PageD.aspx?category=namenitev_dela_dohodnine_fo" target="_blank" class="btn btn-primary btn-external">pojdi na eDavke</a>
                </p>
              </div>
            </div>
          </div>
          <div id="question-4" class="question clearfix" v-if="actualAnswer2 == 'find_org' && showSelectRatios">
            <div class="question__number">4</div>
            <div class="question__content">
              <div class="question__answers">
                <template v-for="(org, index) in selected_orgs">
                  <p><small>{{org.name}}</small></p>
                  <div class="range-slider">
                    <vue-slider
                      v-bind="sliderOptions"
                      @input="recalculateRatios(index)"
                      v-model="selected_ratios[index]"
                      :disabled="selected_ratios.length <= 1"
                    ></vue-slider>
                    <input class="form-control range-slider__value" disabled :value="(selected_ratios[index] / 100) + '%'">
                  </div>
                </template>
              </div>
              <div class="question__label">
                <p>Če ste pomotoma dodali kakšno organizacijo, ki ji ne želite donirati dela dohodnine, izberite 0%.</p>
              </div>
              <p class="text-center question__button">
                <button class="btn btn-primary" @click.prevent="showPersonInfoForm">Nadaljuj z izpolnjevanjem obrazca</button>
              </p>
            </div>
          </div>
          <div id="question-5" class="question clearfix" v-if="actualAnswer2 == 'find_org' && shouldShowPersonInfoForm">
            <div class="question__number">5</div>
            <div class="question__content">
              <form action="/pdf/genPDFfromPOST/" method="POST">
                <input type="hidden" name="template" value="dobrodelen_pdf">
                <input type="hidden" name="filename" value="obrazec_enprocent">
                <input type="hidden" name="source_domain" value="cnvos.si/enprocent">
                <input type="hidden" name="selected_orgs" :value="selectedOrgsForFormValue">
                <div class="question__answers">
                  <div class="form-controls row">
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Ime in priimek" name="name" v-model="personInfoForm.name">
                    </div>
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Naslov" name="address" v-model="personInfoForm.address">
                    </div>
                    <div class="col-sm-4 control-input">
                      <input class="form-control" placeholder="Poštna številka" name="postalCode" v-model="personInfoForm.postalCode" maxlength="4">
                    </div>
                    <div class="col-sm-8 control-input">
                      <input class="form-control" placeholder="Kraj" name="city" v-model="personInfoForm.city">
                    </div>
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Davčna številka" name="taxNumber" v-model="personInfoForm.taxNumber">
                    </div>
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Elektronski naslov" name="email" v-model="personInfoForm.email">
                    </div>
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Telefonska številka" name="phone" v-model="personInfoForm.phone">
                    </div>
                  </div>
                </div>
                <p>
                  Ko boste izpolnili obrazec, imate dve možnosti:
                </p>
                <ol>
                  <li>
                    Če želite podatke sami posredovati Fursu, boste prejeli PDF datoteko. To natisnete in posredujete Fursu.  V tem primeru ne shranjujemo nobenih
                    vaših podatkov.
                  </li>
                  <li>
                    Lahko pa vse uredite elektronsko ter tiskanje in pošiljanje prepustite nam. Obrazce bomo posredovali Fursu vsakega 28. v mesecu, razen decembra
                    že 20. v mesecu. Vaše podatke bomo izbrisali dan po tem, ko bomo vaš obrazec poslali Fursu. Več o splošnih pogojih uporabe in obdelavi osebnih
                    podatkov si preberite <a href="https://www.cnvos.si/nvo-vseved/enprocent/splosni-pogoji/" target="_blank">tukaj</a>.
                  </li>
                </ol>
                <p class="text-center question__button">
                  <button class="btn btn-primary" :disabled="personInfoFormHasErrors" v-if="!shouldShowSignatureForm || personInfoFormHasErrors">
                    <i class="glyphicon glyphicon-download-alt"></i> Prenesi in pošlji obrazec sam
                  </button>
                  <button v-if="showSendToCnvosButton" class="btn btn-primary" type="button" :disabled="personInfoFormHasErrors" @click.prevent="showSignatureForm">
                    <i class="glyphicon glyphicon-pencil"></i> Podpiši in posreduj CNVOS-u
                  </button>
                </p>
              </form>
            </div>
          </div>
          <div id="question-6" class="question clearfix" v-if="shouldShowSignatureForm && !personInfoFormHasErrors">
            <div class="question__number">6</div>
            <div class="question__content">
              <form action="/pdf/genPDFfromPOST/" method="POST">
                <input type="hidden" name="template" value="dobrodelen_pdf">
                <input type="hidden" name="filename" value="obrazec_enprocent">
                <input type="hidden" name="source_domain" value="cnvos.si/enprocent">
                <input type="hidden" name="skip_save" value="true" v-if="signedPdfSubmitted">
                <input type="hidden" name="selected_orgs" :value="selectedOrgsForFormValue">
                <input type="hidden" name="name" :value="personInfoForm.name">
                <input type="hidden" name="address" :value="personInfoForm.address">
                <input type="hidden" name="postalCode" :value="personInfoForm.postalCode">
                <input type="hidden" name="city" :value="personInfoForm.city">
                <input type="hidden" name="taxNumber" :value="personInfoForm.taxNumber">
                <input type="hidden" name="email" :value="personInfoForm.email">
                <input type="hidden" name="phone" :value="personInfoForm.phone">
                <input type="hidden" name="signature" :value="signatureDataUrl">
                <template v-if="!signedPdfSubmitted">
                  <p>Podpišite se v spodnje polje &mdash; če naprava podpira dotik, lahko uporabite prst ali digitalni svinčnik, drugače pa miško.</p>
                  <p>
                    Obrazce bomo pošiljali Fursu vsak 28. dan v mesecu, razen decembra, ko bomo obrazce poslali že 20. v mesecu. Več o  splošnih pogojih
                    uporabe in obdelavi osebnih podatkov si preberite <a href="https://www.cnvos.si/nvo-vseved/enprocent/splosni-pogoji/" target="_blank">tukaj</a>.
                    S posredovanjem obrazca CNVOS se strinjate, da CNVOS v vašem imenu obrazec pošlje na Furs.
                  </p>
                  <p>
                    <signature-pad :key="signaturePadKey" @ready="onSignatureReady" @change="onSignatureChange" />
                  </p>
                  <div>
                    <button class="btn btn-link btn-sm" style="padding:0" type="button" @click.prevent="resetSignature">Izbriši podpis</button>
                  </div>

                  <p class="text-center question__button">
                    <button class="btn btn-primary" type="button" :disabled="signatureFormHasErrors" @click.prevent="onSubmitPDF" >
                      Potrdi in posreduj obrazec CNVOS-u
                    </button>
                  </p>
                </template>
                <template v-else>
                  <p class="text-center" style="margin-top: 3rem; font-weight: 700;">
                    Hvala, prejeli smo vaš obrazec. Če imate kakršna koli vprašanja, nam pišite na <a href="mailto:info@cnvos.si" target="_blank">info@cnvos.si</a>.
                  </p>
                  <p class="text-center question__button">
                    <button class="btn btn-primary" :disabled="signatureFormHasErrors">
                      <i class="glyphicon glyphicon-download-alt"></i> Prenesi kopijo obrazca
                    </button>
                  </p>
                </template>
              </form>
            </div>
          </div>
        </template>
        <template v-if="actualAnswer1 === 'org'">
          <div id="question-2" class="question clearfix" v-if="actualAnswer1 === 'org' && !actualAnswer2">
            <div class="question__number">2</div>
            <div class="question__content">
              <div class="question__answers">
                <form>
                  <div class="radio">
                    <input type="radio" id="question-2-1" value="become" v-model="answer2">
                    <label for="question-2-1">Želim postati upravičenec/prejemnik donacij.</label>
                  </div>
                  <div class="radio">
                    <input type="radio" id="question-2-2" value="plugin" v-model="answer2">
                    <label for="question-2-2">Sem že upravičenec in želim gradnik za svoje spletno mesto.</label>
                  </div>
                </form>
              </div>
              <div class="question__button">
                <button type="button" class="btn btn-primary btn-external" :disabled="!answer2" @click="onNextAnswer2">Naprej</button>
              </div>
            </div>
          </div>
          <!-- QUESTION 3 -->
          <template v-if="actualAnswer2 == 'become'">
            <div id="question-3" class="question clearfix">
              <div class="question__number">3</div>
              <div class="question__content">
                <div class="question__label">
                  Izberite področje dela
                </div>
                <div class="question__answers">
                  <form v-if="dobrodelenKeysBecome && dobrodelenKeysBecome.pravne_oblike && dobrodelenKeysBecome.vsebine">
                    <!-- skrij izbiro, forsiraj izbiro "Društvo, zavod ali druga nepridobitna organizacija" -->
                    <!-- <search-dropdown :placeholder="legalFormPlaceholder" :items="dobrodelenKeysBecome.pravne_oblike" @change="checkBecomeForm" single></search-dropdown> -->
                    <search-dropdown v-if="areasOrgItems" :placeholder="areasOrgPlaceholder" :items="areasOrgItems" @change="checkBecomeForm" single></search-dropdown>
                  </form>
                </div>
              </div>
            </div>
            <div id="question-4" class="question clearfix" v-if="actualAnswer2 == 'become' && legalFormSelected.length && areasOrgSelected.length">
              <div class="question__number">4</div>
              <div class="question__content" v-if="becomeContentText">
                <div class="info__title info__title--alone" v-if="becomeTitleText">
                  <h2>{{ becomeTitleText }}</h2>
                </div>
                <div class="question__label block-paragraph" v-html="becomeContentText" v-externallinks v-tooltips></div>
              </div>
            </div>
          </template>
          <div id="question-3" class="question clearfix" v-if="actualAnswer2 == 'plugin'">
            <div class="question__number">3</div>
            <div class="question__content">
              <div class="question__label">
                <p>
                  Za nevladne organizacije, ki ste skladno z Uredbo o namenitvi dela dohodnine za donacije upravičene do donacij, smo pripravili posebno
                  aplikacijo. Gradnik si lahko brezplačno namestite na svojo spletno stran. V spodnji obrazec vpišite informacije o svoji organizaciji.
                  Ko vnesete vse podatke, kliknite na gumb 'kopiraj kodo' ter kodo prilepite v HTML kodo svojega spletnega mesta. Davčni zavezanci bodo
                  v gradnik na vaši spletni strani vnesli svoje podatke, natisnili obvestilo ter svojo odločitev sporočili na finančni urad oziroma
                  obrazec podpisali in ga poslali na CNVOS. Obrazce bomo na Furs pošiljali vsak 28. dan v mesecu, razen decembra, ko bomo obrazce
                  odposlali 20. v mesecu.
                </p>
                <p>
                  Podatki, ki jih bodo davčni zavezanci vpisovali v obrazec na vaši spletni strani, se pri vas ne shranjujejo.
                </p>
              </div>
              <div class="question__answers">
                <form @submit.prevent>
                  <div class="form-controls row">
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Davčna številka" v-model="ngoInfoForm.taxNumber" maxlength="8">
                      <strong v-if="ngoInfoFormTaxNumberNotFound" class="small text-danger">Ta davčna številka ni upravičena do donacij dohodnine.</strong>
                    </div>
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Naziv organizacije" :disabled="!ngoInfoFormHasValidTaxNumber" v-model="ngoInfoForm.name">
                    </div>
                    <div class="col-sm-12 control-input">
                      <input class="form-control" placeholder="Naslov" :disabled="!ngoInfoFormHasValidTaxNumber" v-model="ngoInfoForm.address">
                    </div>
                    <div class="col-sm-4 control-input">
                      <input class="form-control" placeholder="Poštna številka" :disabled="!ngoInfoFormHasValidTaxNumber" v-model="ngoInfoForm.postalCode" maxlength="4">
                    </div>
                    <div class="col-sm-8 control-input">
                      <input class="form-control" placeholder="Kraj" :disabled="!ngoInfoFormHasValidTaxNumber" v-model="ngoInfoForm.city">
                    </div>
                  </div>
                </form>
              </div>
              <p class="text-center question__button">
                <button class="btn btn-primary" :disabled="ngoInfoFormHasErrors" @click="showWidgetPreview">predogled</button>
                <button class="btn btn-primary" :disabled="ngoInfoFormHasErrors" @click="copyWidgetCode">kopiraj kodo</button>
              </p>
              <p class="text-center question__button" v-if="copiedWidgetCode">
                HTML koda skopirana v odložišče
              </p>
            </div>
            <div id="widget-preview" class="question__label row" v-if="showingWidgetPreview">
              <widget-two v-bind="ngoInfoForm" percent="1.0" source-domain="cnvos.si" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/transition';
import 'bootstrap/js/collapse';
import _ from 'lodash';
import queryString from 'query-string';
import copy from 'copy-to-clipboard';
import VueSlider from 'vue-slider-component';
import SearchDropdown from '../components/SearchDropdown.vue';
import WidgetTwo from './WidgetV2.vue';
import SignaturePad from './SignaturePad.vue';

const MAX_SLIDER_SUM = 100;

export default {
  name: 'app',
  created() {
    this.originalTitle = document.title;
    $.getJSON('/enprocent/getDobrodelenAreas/').done((data) => {
      this.areas = data.areas;
      this.loadFromUrl();
    });
    $.getJSON('/enprocent/getDobrodelenKeys/').done((data) => {
      // forsiraj izbiro "Društvo, zavod ali druga nepridobitna organizacija"
      data.pravne_oblike.forEach((po) => {
        po.selected = po.id === '4';
      });
      //
      this.dobrodelenKeysBecome = data;
      this.loadFromUrl();
    });
  },
  data() {
    return {
      isDragging: -1,
      sliderOptions: {
        interval: 10,
        piecewise: true,
        min: 0,
        max: MAX_SLIDER_SUM,
        height: 4,
        dotSize: 20,
        tooltip: 'never',
        speed: 0,
        class: 'slider slider--purple',
      },
      answer1: '',
      answer2: '',
      answer3: '',
      answer4: '',
      actualAnswer1: '',
      actualAnswer2: '',
      selected_orgs: [],
      selected_ratios: [],
      areas: [],
      findOrgResults: null,
      findOrgKeyword: null,
      findOrgTaxNumber: null,
      findOrgPostal: null,
      findOrgArea: null,
      findOrgLoading: false,
      selectedTooMany: false,
      showSelectRatios: false,
      shouldShowPersonInfoForm: false,
      shouldShowSignatureForm: false,
      signaturePadKey: 1,
      signatureFormHasErrors: true,
      signatureDataUrl: null,
      signedPdfSubmitted: false,
      personInfoForm: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        email: '',
        phone: '',
      },
      ngoInfoForm: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        percent: '1.0',
      },
      ngoInfoFormHasValidTaxNumber: false,
      ngoInfoFormTaxNumberNotFound: false,
      copiedWidgetCode: false,
      showingWidgetPreview: false,
      dobrodelenKeysBecome: false,
      originalTitle: null,
      becomeTitleText: null,
      becomeContentText: null,
      isLoadingFromUrl: false,
    };
  },
  mounted() {
    window.addEventListener('popstate', (event) => {
      this.onPopState(event.state);
    });
  },
  watch: {
    // answer3(value) {
    //   const map = {
    //     1: 'keyword',
    //     2: 'tax',
    //     3: 'postal',
    //     4: 'area',
    //   };
    //   if (value === '1' && this.findOrgKeyword) {
    //     this.fetchOrgResults(this.findOrgKeyword, map[value]);
    //   } else if (value === '2' && this.findOrgTaxNumber) {
    //     this.fetchOrgResults(this.findOrgTaxNumber, map[value]);
    //   } else if (value === '3' && this.findOrgPostal) {
    //     this.fetchOrgResults(this.findOrgPostal, map[value]);
    //   } else if (value === '4' && this.findOrgArea) {
    //     this.fetchOrgResults(this.findOrgArea, map[value]);
    //   }
    //   if (!this.isLoadingFromUrl) {
    //     this.trackContentInteraction('answer3', map[value]);
    //     // this.scrollTo('#find-org-radios');
    //     this.answer4 = '';
    //   }
    // },
    findOrgKeyword(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'keyword');
    },
    findOrgTaxNumber(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'tax');
    },
    findOrgPostal(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'postal');
    },
    findOrgArea(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'area');
    },
    'personInfoForm.postalCode': function handler(newVal) {
      if (newVal && newVal.length === 4) {
        $.getJSON(`/enprocent/getFURS/${newVal}/`).done((data) => {
          this.personInfoForm.city = data.city;
        });
      }
    },
    'ngoInfoForm.postalCode': function handler(newVal) {
      if (newVal && newVal.length === 4) {
        $.getJSON(`/enprocent/getFURS/${newVal}/`).done((data) => {
          this.ngoInfoForm.city = data.city;
        });
      }
    },
    'ngoInfoForm.taxNumber': function handler(newVal) {
      this.ngoInfoFormHasValidTaxNumber = false;
      // this.ngoInfoFormTaxNumberNotFound = false;
      if (newVal && newVal.length === 8) {
        $.getJSON(`/enprocent/findNGOByTaxNumber/${newVal}/`).done((data) => {
          if (data && data.found) {
            this.ngoInfoForm.name = data.ngo.name;
            this.ngoInfoForm.address = data.ngo.address;
            this.ngoInfoForm.postalCode = data.ngo.postal_code;
            this.ngoInfoForm.city = data.ngo.city;
            this.ngoInfoFormTaxNumberNotFound = false;
            this.ngoInfoFormHasValidTaxNumber = true;
          } else {
            this.ngoInfoFormTaxNumberNotFound = true;
          }
        });
      }
    },
    legalFormSelected() {
      if (this.dobrodelenKeysBecome && this.dobrodelenKeysBecome.vsebine) {
        this.dobrodelenKeysBecome.vsebine.forEach((e) => {
          this.$set(e, 'selected', false);
        });
        // this.checkBecomeForm();
      }
    },
  },
  computed: {
    areasSelected() {
      return this.areas
        .filter(e => e.selected)
        .map(e => e.label);
    },
    areasPlaceholder() {
      return this.areasSelected.length ? `${this.areasSelected}` : 'Izberite področje dela';
    },
    areasOrgSelected() {
      if (this.areasOrgItems) {
        return this.areasOrgItems
          .filter(e => e.selected);
      }
      return [];
    },
    areasOrgPlaceholder() {
      return this.areasOrgSelected.length ? `${this.areasOrgSelected[0].label}` : 'Področje dela';
    },
    areasOrgItems() {
      if (this.dobrodelenKeysBecome && this.legalFormSelected.length) {
        return this.dobrodelenKeysBecome.vsebine
          .filter(e => e.pravna_oblika === this.legalFormSelected[0].id);
      }
      return null;
    },
    legalFormSelected() {
      if (this.dobrodelenKeysBecome) {
        return this.dobrodelenKeysBecome.pravne_oblike
          .filter(e => e.selected);
      }
      return [];
    },
    legalFormPlaceholder() {
      return this.legalFormSelected.length ? `${this.legalFormSelected[0].label}` : 'Pravna oblika';
    },
    personInfoFormHasErrors() {
      if (Object.keys(this.personInfoForm).some(e => !this.personInfoForm[e])) {
        return true;
      }
      if (this.personInfoForm.name.trim().length < 3 || this.personInfoForm.name.trim().indexOf(' ') === -1) {
        return true;
      }
      if (this.personInfoForm.address.trim().length < 3) {
        return true;
      }
      if (!/^\d{4}$/.test(this.personInfoForm.postalCode)) {
        return true;
      }
      if (this.personInfoForm.city.trim().length < 2) {
        return true;
      }
      if (!/^\d{8}$/.test(this.personInfoForm.taxNumber)) {
        return true;
      }
      const phone = this.personInfoForm.phone.replace(/\D/g, '');
      if (phone.length < 7) {
        return true;
      }
      if (!this.personInfoForm.email.includes('@') || !this.personInfoForm.email.includes('.')) {
        return true;
      }
      return false;
    },
    ngoInfoFormHasErrors() {
      if (!this.ngoInfoFormHasValidTaxNumber) {
        return true;
      }
      // TODO: proper validation
      return Object.keys(this.ngoInfoForm).some(e => !this.ngoInfoForm[e]);
    },
    selectedOrgsForFormValue() {
      return this.selected_orgs.map((e, i) => `${e.name}|=|${e.tax_number}|=|${this.selected_ratios[i] / 100}`).join('|-|');
    },
    showSendToCnvosButton() {
      const now = new Date();
      const month = now.getMonth() + 1;
      if (month === 12) {
        return now.getDate() < 21;
      }
      return true;
    }
  },
  methods: {
    resetStuff(state = {}) {
      this.answer3 = '';
      this.answer4 = '';
      // this.legalFormSelected.forEach((e) => {
      //   this.$set(e, 'selected', state.legalForm ? e.label === state.legalForm : false);
      // });
      this.areas.forEach((e) => {
        this.$set(e, 'selected', state.area ? e.label === state.area : false);
      });
      this.findOrgKeyword = null;
      this.findOrgTaxNumber = null;
      this.findOrgPostal = null;
      this.findOrgArea = null;
      this.findOrgResults = null;
      this.selected_orgs = [];
      this.selectedTooMany = false;
      this.selectedTooMany = false;
      this.showSelectRatios = false;
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      this.signaturePadKey++;
      this.signatureFormHasErrors = true;
      this.signatureDataUrl = null;
      this.signedPdfSubmitted = false;
      this.ngoInfoForm = {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        percent: '1.0',
      };
      this.personInfoForm = {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        email: '',
        phone: '',
      };
    },
    onPopState(state) {
      if (state) {
        this.answer1 = state.answer1 || '';
        this.actualAnswer1 = state.actualAnswer1 || '';
        this.answer2 = state.answer2 || '';
        this.actualAnswer2 = state.actualAnswer2 || '';
        this.resetStuff(state);
      } else {
        this.answer1 = '';
        this.actualAnswer1 = '';
        this.answer2 = '';
        this.actualAnswer2 = '';
        this.resetStuff();
      }
      this.updateBreadcrumbs(window.location.href);
    },
    onNextAnswer1() {
      if (!this.isLoadingFromUrl && this.answer1) {
        // this.trackContentInteraction('answer1', newVal);
        this.$nextTick(() => {
          // this.scrollTo('#question-2');
          this.changeUrl(1);
        });
        this.actualAnswer1 = this.answer1;
        this.answer2 = '';
        this.resetStuff();
      }
    },
    onNextAnswer2(newVal) {
      if (!this.isLoadingFromUrl && this.answer2) {
        // this.trackContentInteraction('answer2', newVal);
        this.$nextTick(() => {
          // this.scrollTo('#question-3');
          // this.changeUrl(2);
          this.checkBecomeForm();
        });
        this.actualAnswer2 = this.answer2;
        this.resetStuff();
      }
    },
    fetchOrgResults: _.debounce(function fetchOrgResults(value, field) {
      if (typeof value !== 'undefined' && value !== '') {
        const val = _.isString(value) ? value.toUpperCase() : value;
        const url = field === 'area' ? `/enprocent/searchNGOsByArea/${val}/` : `/enprocent/searchNGOs/${val}/`;
        $.getJSON(url + `?f=${field}`).done((data) => {
          const sortedData = data.slice().sort((a, b) => a.name.localeCompare(b.name, 'sl'));
          this.findOrgResults = sortedData;
          this.findOrgLoading = false;
        });
      } else {
        this.findOrgResults = null;
        this.findOrgLoading = false;
      }
    }, 500),
    selectOrg(org) {
      this.selectedTooMany = false;
      this.showSelectRatios = false;
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      const index = this.selected_orgs.findIndex(e => e.id === org.id);
      if (index !== -1) {
        this.selected_orgs.splice(index, 1);
        this.trackContentInteraction('un-selectOrg', org.name);
      } else if (this.selected_orgs.length >= 10) {
        this.selectedTooMany = true;
        this.trackContentInteraction('selectedTooMany', org.name);
      } else {
        this.selected_orgs.push(org);
        this.trackContentInteraction('selectOrg', org.name);
      }
    },
    isSelectedOrg(org) {
      return this.selected_orgs.find(e => e.id === org.id) != null;
    },
    selectRatios() {
      this.trackContentInteraction('selectRatios', this.selected_orgs.length);
      this.answer4 = '';
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      this.showSelectRatios = true;
      this.selected_ratios = Array(this.selected_orgs.length);
      for (let i = 0; i < this.selected_ratios.length; i += 1) {
        this.selected_ratios[i] = 0;
      }
      this.recalculateRatios();
      this.$nextTick(() => {
        this.scrollTo('#question-4');
      });
    },
    recalculateRatios(index) {
      const ratios = this.selected_ratios;
      const step = 10;

      let sum = _.sum(ratios);
      if (index === undefined) {
        while (sum < MAX_SLIDER_SUM) {
          let lowestIndex = -1;
          for (let j = 0; j < ratios.length; j += 1) {
            if (ratios[j] < ratios[lowestIndex] || lowestIndex === -1) {
              lowestIndex = j;
            }
          }
          ratios[lowestIndex] += step;
          sum += step;
        }
      } else if (sum > MAX_SLIDER_SUM) {
        while (sum > MAX_SLIDER_SUM) {
          let highestIndex = -1;
          for (let j = ratios.length - 1; j >= 0; j -= 1) {
            if (j !== index) {
              if (ratios[j] > ratios[highestIndex] || highestIndex === -1) {
                highestIndex = j;
              }
            }
          }
          ratios[highestIndex] -= step;
          sum -= step;
        }
      } else if (sum < MAX_SLIDER_SUM) {
        while (sum < MAX_SLIDER_SUM) {
          let lowestIndex = -1;
          for (let j = 0; j < ratios.length; j += 1) {
            if (j !== index) {
              if (ratios[j] < ratios[lowestIndex] || lowestIndex === -1) {
                lowestIndex = j;
              }
            }
          }
          ratios[lowestIndex] += step;
          sum += step;
        }
      }
    },
    continueToEdavki() {
      this.trackContentInteraction('continueToEdavki', '');
      this.answer4 = 'edavki';
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      this.showSelectRatios = false;
      this.$nextTick(() => {
        this.scrollTo('#question-4');
      });
    },
    showPersonInfoForm() {
      this.trackContentInteraction('showPersonInfoForm', '');
      const removeIndexes = [];
      this.selected_ratios.forEach((ratio, index) => {
        if (ratio <= 0) {
          removeIndexes.push(index);
        }
      });
      this.selected_orgs = this.selected_orgs.filter((o, i) => removeIndexes.indexOf(i) === -1);
      this.selected_ratios = this.selected_ratios.filter((o, i) => removeIndexes.indexOf(i) === -1);

      // TODO: proper validation
      this.shouldShowPersonInfoForm = true;
      this.shouldShowSignatureForm = false;
      this.$nextTick(() => {
        this.scrollTo('#question-5');
      });
    },
    showSignatureForm() {
      this.shouldShowSignatureForm = true;
      this.$nextTick(() => {
        this.scrollTo('#question-6');
      });
    },
    onSignatureChange(pad) {
      this.signatureFormHasErrors = pad.isEmpty();
      this.signatureDataUrl = pad.toDataURL();
    },
    onSignatureReady(pad) {
      this.signatureFormHasErrors = true;
      this.signatureDataUrl = null;
      this.signedPdfSubmitted = false;
    },
    resetSignature() {
      this.signaturePadKey++;
    },
    scrollTo(selector) {
      if (this.isLoadingFromUrl) {
        return;
      }
      const offset = $(selector).offset();
      if (offset && offset.top) {
        $('html, body').animate({
          scrollTop: offset.top,
        }, 500);
      }
    },
    checkBecomeForm() {
      if (this.answer2 === 'become' && this.legalFormSelected.length && this.areasOrgSelected.length) {
        const legalForms = this.legalFormSelected;
        const areas = this.areasOrgSelected;
        const legalForm = legalForms.map(e => e.label)[0];
        const area = areas.map(e => e.label)[0];

        // this.trackContentInteraction('checkBecomeForm', `${legalForm} - ${area}`);

        const contentID = areas.map(e => e.id)[0];

        $.getJSON(`/enprocent/getDobrodelenContent/${contentID}/`).done((data) => {
          if (data.success) {
            this.becomeTitleText = data.title;
            this.becomeContentText = data.content;
            this.$nextTick(() => {
              // this.scrollTo('#question-4');
              this.changeUrl(3, legalForm, area);
              this.setNewTitle(this.becomeTitleText);
            });
          } else {
            this.becomeTitleText = '';
            this.becomeContentText = ':(';
          }
        });
      } else {
        this.changeUrl(2);
        this.setNewTitle();
      }
    },
    setNewTitle(newVal) {
      if (newVal) {
        document.title = newVal + ' - ' + this.originalTitle;
      } else {
        document.title = this.originalTitle;
      }
    },
    copyWidgetCode() {
      this.trackContentInteraction('copyWidgetCode', '');
      const qs = queryString.stringify(this.ngoInfoForm);
      let htmlCode = '';
      htmlCode += `<iframe id="enprocent_iframe" frameborder="0" width="800" height="600" style="max-width:100%;" src="https://www.cnvos.si/enprocent/embed/v2/?${qs}"></iframe>`;
      htmlCode += '<script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.min.js"></' + 'script><script>iFrameResize({checkOrigin:false},\'#enprocent_iframe\');</' + 'script>';
      const copied = copy(htmlCode, { debug: true });
      if (copied) {
        this.copiedWidgetCode = true;
        setTimeout(() => {
          this.copiedWidgetCode = false;
        }, 3000);
      }
    },
    showWidgetPreview() {
      this.trackContentInteraction('showWidgetPreview', '');
      this.showingWidgetPreview = true;
      this.$nextTick(() => {
        this.scrollTo('#widget-preview');
      });
    },
    changeUrl(limit, legalForm, area) {
      if (this.isLoadingFromUrl) {
        return;
      }
      let url = '/enprocent/';
      if (limit > 0) {
        if (this.answer1 === 'person') {
          url += 'posameznik/';
        } else if (this.answer1) {
          url += 'nvo/';
        }
      }
      if (limit > 1) {
        if (this.answer2 === 'edavki') {
          url += 'edavki/';
        } else if (this.answer2 === 'find_org') {
          url += 'poisci/';
        } else if (this.answer2 === 'become') {
          url += 'postani-upravicenec/';
        } else if (this.answer2) {
          url += 'gradnik/';
        }
      }
      if (limit > 2 && legalForm && area) {
        url += `${_.kebabCase(legalForm)}/${_.kebabCase(area)}`;
      }
      if (window.history && window.history.pushState) {
        const newState = {
          answer1: this.answer1,
          actualAnswer1: this.actualAnswer1,
          answer2: this.answer2,
          actualAnswer2: this.actualAnswer2,
          legalForm,
          area,
        };
        window.history.pushState(newState, '', url);
        this.updateBreadcrumbs(url);
      }
    },
    updateBreadcrumbs(url) {
      if (url.startsWith('http')) {
        const urlObj = new URL(url);
        url = urlObj.pathname;
      }
      console.log('updateBreadcrumbs', url);

      const urlSplit = url.split('/').filter(e => e.length);
      const rootPart = urlSplit[0];
      const urlParts = urlSplit.slice(1);
      const breadcrumbs = document.querySelector('.page-breadcrumbs');

      const extraItems = breadcrumbs.querySelectorAll('.dobrodelen-extra');
      extraItems.forEach((item) => {
        item.remove();
      });

      const separator = breadcrumbs.querySelector('.page-breadcrumbs__separator');
      const lastItem = breadcrumbs.querySelector('.page-breadcrumbs__item:last-child');
      const lastItemText = lastItem ? lastItem.textContent.trim() : '';

      if (urlParts.length) {
        const span = lastItem.querySelector('span');
        if (span) {
          span.remove();
          const link = document.createElement('a');
          link.className = 'page-breadcrumbs__link';
          link.href = `/${rootPart}/`;
          link.textContent = lastItemText;
          lastItem.appendChild(link);
        }
      } else {
        const link = lastItem.querySelector('a');
        if (link) {
          link.remove();
          const span = document.createElement('span');
          span.className = 'page-breadcrumbs__current';
          span.textContent = lastItemText;
          lastItem.appendChild(span);
        }
      }

      urlParts.forEach((part, index) => {
        let label = '';
        if (index === 0) {
          if (part === 'posameznik') {
            label = 'posameznik';
          } else if (part === 'nvo') {
            label = 'organizacija';
          }
        }
        if (index === 1) {
          if (part === 'edavki') {
            label = 'e-davki';
          } else if (part === 'poisci') {
            label = 'poišči organizacijo';
          } else if (part === 'postani-upravicenec') {
            label = 'postani upravičenec';
          } else if (part === 'gradnik') {
            label = 'gradnik za spletno stran';
          }
        }
        if (label) {
          const sep = separator.cloneNode(true);
          sep.className += ' dobrodelen-extra';
          breadcrumbs.appendChild(sep);

          const item = document.createElement('div');
          item.className = 'page-breadcrumbs__item dobrodelen-extra';
          if (index === urlParts.length - 1) {
            const span = document.createElement('span');
            span.className = 'page-breadcrumbs__current';
            span.textContent = label;
            item.appendChild(span);
          } else {
            const link = document.createElement('a');
            link.className = 'page-breadcrumbs__link';
            link.href = `/${rootPart}/` + urlParts.slice(0, index + 1).join('/') + '/';
            link.textContent = label;
            item.appendChild(link);
          }
          breadcrumbs.appendChild(item);
        }
      });
    },
    loadFromUrl() {
      if (this.isLoadingFromUrl || !this.areas || !this.dobrodelenKeysBecome) {
        return;
      }
      const url = window.location.pathname;
      if (url && url.indexOf('/enprocent') === 0) {
        this.isLoadingFromUrl = true;
        const parts = url.split('/').filter(e => e.length).slice(1);
        for (let i = 0; i < parts.length; i += 1) {
          const part = parts[i];
          console.log(part, i);
          if (i === 0) {
            if (parts[i] === 'posameznik') {
              this.answer1 = 'person';
              this.actualAnswer1 = 'person';
            } else {
              this.answer1 = 'org';
              this.actualAnswer1 = 'org';
            }
          }
          if (i === 1) {
            if (parts[i] === 'edavki') {
              this.answer2 = 'edavki';
              this.actualAnswer2 = 'edavki';
            } else if (parts[i] === 'poisci') {
              this.answer2 = 'find_org';
              this.actualAnswer2 = 'find_org';
            } else if (parts[i] === 'postani-upravicenec') {
              this.answer2 = 'become';
              this.actualAnswer2 = 'become';
            } else {
              this.answer2 = 'plugin';
              this.actualAnswer2 = 'plugin';
            }
          }
          if (i === 2) {
            const legalForm = this.dobrodelenKeysBecome.pravne_oblike
              .find(e => parts[i] === _.kebabCase(e.label));
            if (legalForm) {
              this.$set(legalForm, 'selected', true);
            }
          }
          if (i === 3) {
            this.$nextTick(() => {
              this.isLoadingFromUrl = false;
              const area = this.areasOrgItems.find(e => parts[i] === _.kebabCase(e.label));
              if (area) {
                this.$set(area, 'selected', true);
              }
              this.$nextTick(() => {
                this.checkBecomeForm();
                this.isLoadingFromUrl = false;
              });
            });
          }
        }
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.isLoadingFromUrl = false;
              this.updateBreadcrumbs(window.location.href);
            });
          });
        });
      }
    },
    trackContentInteraction(contentName, contentPiece) {
      /* eslint-disable no-underscore-dangle */
      // window._paq = window._paq || [];
      // window._paq.push(['trackContentInteraction', 'nulapetClick', contentName, contentPiece, 'https://www.cnvos.si/enprocent/']);
      // trackContentInteraction(contentInteraction, contentName, contentPiece, contentTarget)
    },
    onSubmitPDF(event) {
      const form = event.target.closest('form');
      if (form) {
        const formData = new FormData(form);
        $.ajax({
          url: form.action,
          data: formData,
          processData: false,
          contentType: false,
          type: 'POST',
          success: (...args) => {
            this.signedPdfSubmitted = true;
          }
        });
      }
    }
  },
  directives: {
    externallinks(el) {
      $(el).find('a[href^="http://"],a[href^="https://"]').attr('target', '_blank');
    },
    tooltips(el) {
      $(el).find('[data-toggle="tooltip"]').tooltip({
        container: 'body',
      });

      $(el).find('.bootstrap-accordion-title').each(function fixCollapsedClass() {
        const $this = $(this);
        const $body = $this.closest('.panel').find('.panel-collapse.collapse');
        $this.toggleClass('collapsed', !$body.hasClass('in'));
      });

      $(el).find('[data-toggle="collapse"]').collapse();

      $(el).find('.accordion-parent').on('show.bs.collapse', '.panel', function onShown() {
        const $panel = $(this).closest('.panel');
        $('html, body').animate({
          scrollTop: $panel.offset().top,
        }, {
          duration: 350,
          step: (now, tween) => {
            tween.end = $panel.offset().top;
          },
        });
      });
    },
  },
  components: {
    VueSlider,
    SearchDropdown,
    WidgetTwo,
    SignaturePad,
  },
};
</script>



// WEBPACK FOOTER //
// src/dobrodelen/App.vue